import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux'
import { setSelectedFeedback, ajaxFeedback, getRequestedVia, getStarsJSX, getChatStatus } from '../redux/FeedbackRedux';


class AttachmentSection extends React.Component {
    render () {

        let attachments = this.props.attachments;
        if(attachments && attachments.length >= 1) {
            return (
                <div className="card-body border-top attachments" id="feedback_detail_attachments">
                    <h4 className="mb-3">Attachments:</h4>
                        <div className="row">
                            {attachments}
                        </div>
                </div>
             );
        }

        return null;
	}
}

export default AttachmentSection;
